/* Frida Australia theme — shared behaviour (no dependencies) */
(function () {
  'use strict';

  // Drawers (menu)
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = document.getElementById(btn.getAttribute('data-drawer-open'));
      if (!d) return;
      d.setAttribute('open', ''); d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-drawer]').forEach(function (d) {
    d.querySelectorAll('[data-drawer-close]').forEach(function (c) {
      c.addEventListener('click', function () { d.removeAttribute('open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; });
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-drawer][open]').forEach(function (d) { d.removeAttribute('open'); document.body.style.overflow = ''; });
  });

  // Tabs / filters: [data-tabs] container, .tab[data-tab="key"], panels [data-tab-panel="key"] or filter items [data-tab-item="a b"]
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('.tab');
    var scope = group.getAttribute('data-tabs-scope') ? document.querySelector(group.getAttribute('data-tabs-scope')) : document;
    function activate(key) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tab') === key ? 'true' : 'false'); });
      scope.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
      scope.querySelectorAll('[data-tab-item]').forEach(function (it) {
        var keys = it.getAttribute('data-tab-item').split(/\s+/);
        it.hidden = !(key === 'all' || keys.indexOf(key) > -1);
      });
      var count = scope.querySelector('[data-tab-count]');
      if (count) { var sel = count.getAttribute('data-tab-count') || '[data-tab-item]'; var n = 0; scope.querySelectorAll(sel).forEach(function (it) { if (!it.hidden) n++; }); count.textContent = n; }
      scope.querySelectorAll('.stockist-dir__list').forEach(function (l) { l.scrollTop = 0; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.getAttribute('data-tab')); }); });
    var initial = group.querySelector('.tab[aria-selected="true"]') || tabs[0];
    if (initial) activate(initial.getAttribute('data-tab'));
  });

  // Image switcher: [data-gallery] with .thumb[data-index] and img[data-slide]
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var thumbs = g.querySelectorAll('[data-index]');
    var slides = g.querySelectorAll('[data-slide]');
    function go(i) {
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== String(i); });
      thumbs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-index') === String(i) ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(t.getAttribute('data-index')); }); });
    go(thumbs.length ? thumbs[0].getAttribute('data-index') : 0);
  });

  // AJAX add to cart from product cards
  document.querySelectorAll('form[data-ajax-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-button]');
      var label = btn ? btn.querySelector('span') : null;
      var original = label ? label.textContent : '';
      if (btn) btn.setAttribute('aria-disabled', 'true');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name=id]').value, quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        if (label) label.textContent = (window.themeStrings && window.themeStrings.added) || 'Added';
        window.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () { if (label) label.textContent = original; if (btn) btn.removeAttribute('aria-disabled'); }, 2200);
      }).catch(function () { if (btn) btn.removeAttribute('aria-disabled'); });
    });
  });

  // Free gifts, added and removed automatically:
  //   1. threshold gift: the Frida Mom gift (Perineal Foam) once qualifying lines reach the threshold
  //   2. kit gift: a product (SkinSoother) whenever one of the listed kits is in the bag (campaign)
  // Each gift line carries properties._gift ('1' or '2') so the bag can show "Remove gift" and
  // remember a decline per gift. If Shopify ever charges for an auto-added gift (another
  // discount won), it is removed rather than sold.
  (function () {
    var b = document.body;
    var rules = [];
    if (b.getAttribute('data-gift-variant')) rules.push({ kind: '1', variant: parseInt(b.getAttribute('data-gift-variant'), 10), pid: parseInt(b.getAttribute('data-gift-product'), 10), thr: parseInt(b.getAttribute('data-gift-threshold'), 10) * 100, ids: (b.getAttribute('data-gift-products') || '').split(',').filter(Boolean).map(Number), declineKey: 'frida_gift_declined' });
    if (b.getAttribute('data-kit-gift-variant')) rules.push({ kind: '2', variant: parseInt(b.getAttribute('data-kit-gift-variant'), 10), pid: parseInt(b.getAttribute('data-kit-gift-product'), 10), triggers: (b.getAttribute('data-kit-gift-triggers') || '').split(',').filter(Boolean).map(Number), declineKey: 'frida_kit_gift_declined' });
    if (!rules.length) return;
    var busy = false;
    var post = function (url, payload) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) }); };
    function plan(rule, cart) {
      var giftLines = [], autoLine = null, qualifies = false, qualifying = 0;
      cart.items.forEach(function (it) {
        if (it.product_id === rule.pid) { giftLines.push(it); if (it.properties && it.properties._gift === rule.kind) autoLine = it; return; }
        if (rule.thr) { if (rule.ids.indexOf(it.product_id) !== -1) qualifying += it.final_line_price; }
        else if (rule.triggers.indexOf(it.product_id) !== -1) qualifies = true;
      });
      if (rule.thr) qualifies = qualifying >= rule.thr;
      var declined = false;
      try { declined = sessionStorage.getItem(rule.declineKey) === '1'; } catch (e) {}
      if (!qualifies && declined) { declined = false; try { sessionStorage.removeItem(rule.declineKey); } catch (e) {} }
      if (autoLine && autoLine.final_line_price > 0) {
        // Another discount beat the gift at checkout: never charge for an auto-added gift
        try { sessionStorage.setItem(rule.declineKey, '1'); } catch (e) {}
        return post('/cart/change.js', { id: autoLine.key, quantity: 0 });
      }
      if (qualifies && giftLines.length === 0 && !declined) return post('/cart/add.js', { items: [{ id: rule.variant, quantity: 1, properties: { _gift: rule.kind } }] });
      if (!qualifies && autoLine) return post('/cart/change.js', { id: autoLine.key, quantity: 0 });
      if (autoLine && autoLine.quantity > 1) return post('/cart/change.js', { id: autoLine.key, quantity: 1 });
      return null;
    }
    function sync() {
      if (busy) return;
      busy = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var action = null;
        for (var i = 0; i < rules.length && !action; i++) action = plan(rules[i], cart);
        if (!action) { busy = false; return; }
        return action.then(function () { busy = false; window.dispatchEvent(new CustomEvent('cart:gift')); window.dispatchEvent(new CustomEvent('cart:updated')); }).catch(function () { busy = false; });
      }).catch(function () { busy = false; });
    }
    window.addEventListener('cart:updated', sync);
    sync();
  })();

  // Cart count badge refresh
  window.addEventListener('cart:updated', function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    });
  });

  // Back-in-stock notify (posts to a Shopify Forms/Klaviyo endpoint if configured, else stores locally and shows success)
  document.querySelectorAll('form[data-notify]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var endpoint = form.getAttribute('data-notify-endpoint');
      var done = function () { form.hidden = true; var s = form.parentNode.querySelector('[data-notify-success]'); if (s) s.hidden = false; };
      if (endpoint) {
        fetch(endpoint, { method: 'POST', body: new FormData(form) }).then(done).catch(done);
      } else { done(); }
    });
  });

  // Checklist persistence (per page, localStorage)
  document.querySelectorAll('[data-checklist]').forEach(function (list) {
    var key = 'frida-checklist:' + location.pathname;
    var saved = {}; try { saved = JSON.parse(localStorage.getItem(key) || '{}'); } catch (err) {}
    list.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
      if (saved[cb.value]) cb.checked = true;
      cb.addEventListener('change', function () { saved[cb.value] = cb.checked; try { localStorage.setItem(key, JSON.stringify(saved)); } catch (err) {} });
    });
  });

  // Print buttons
  document.querySelectorAll('[data-print], a[href="#print"]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); window.print(); }); });
})();
